import type { AxiosInstance } from 'axios'

import { BlogDetailInterface } from '../../interfaces/blog'

export const getBlogDetail = (api: AxiosInstance) => (
  blogId: string
): Promise<BlogDetailInterface> => api.get(`/v1.0/admin/blogs/${blogId}`)
